<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";
	import ConfirmModal from "../../../../components/CustomModal/ConfirmModal.svelte";
	import client from "../../../../services/client";
	export let reportData = [];

	let sortColumn = "";
	let sortDirection = 1;
	let isOpen = false;
	let id = -1;

	function toggle(num) {
		isOpen = !isOpen;
		id = num;
	}

	async function handleSubmit() {
		// Handle the confirm action here
		try {
			const data = {
				status: "UnderInvestigation",
			};
			const res = await client(
				`/v1/caseManagement/investigate/case/${id}`,
				{
					method: "PUT",
					version: "Tasking",
					data,
				}
			);
			if (res.status === 204) {
				// close the modal and navigate to the case details page
				isOpen = false;
				navigate(`/issues/case-management/${id}`);
			}
		} catch (error) {
			console.error("Error starting investigation:", error);
			return;
		}
	}
</script>

<CustomTable
	columns={[
		{ key: "id", label: "S/N", type: "index" },
		{ key: "plateNo", label: "Vehicle No", type: "link" },
		{ key: "carAssetOwners", label: "Asset Owner", type: "masterdata" },
		{ key: "createdAt", label: "Case Created", type: "date", sortCol: 1 },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: toggle,
			action: "edit",
		},
	]}
	rows={reportData}
	emptyMessage="There are currently no cases to display."
	on:rowClick={(e) => {
		// get id of row clicked
		id = e.detail.id;
		// open the modal
		isOpen = true;
	}}
/>
<ConfirmModal
	open={isOpen}
	{toggle}
	header="Start Investigation"
	bodyText="You are about to start this investigation. Once started, this report will be assigned to you. Are you sure you want to proceed? "
	buttonText="Confirm"
	buttonColor="primary"
	{handleSubmit}
	outline={false}
	close={() => (isOpen = false)}
/>
